import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { caseStudies } from '../data/caseStudies';
export function Work() {
  return <div className="max-w-5xl mx-auto px-6 pt-24 pb-24" data-id="element-239">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} data-id="element-240">
        <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-6" data-id="element-241">
          Selected Work
        </h1>
        <p className="text-xl text-gray-600 mb-16 max-w-2xl" data-id="element-242">
          A collection of projects focusing on AI/Voice UX, LLM evaluation, and
          0-to-1 product execution.
        </p>

        <div className="space-y-8" data-id="element-243">
          {caseStudies.map((study, index) => <motion.div key={study.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-244">
              <Link to={`/work/${study.id}`} className="group flex flex-col md:flex-row gap-8 p-8 md:p-10 rounded-3xl border border-gray-200 hover:border-black transition-colors bg-white" data-id="element-245">
                <div className="flex-grow" data-id="element-246">
                  <div className="flex items-center gap-4 mb-4" data-id="element-247">
                    <h2 className="text-3xl font-bold" data-id="element-248">{study.title}</h2>
                    <span className="px-3 py-1 bg-gray-100 text-xs font-medium uppercase tracking-wider rounded-full" data-id="element-249">
                      {study.timeline}
                    </span>
                  </div>
                  <p className="text-xl text-gray-600 mb-8 max-w-3xl" data-id="element-250">
                    {study.subtitle}
                  </p>

                  <div className="flex flex-wrap gap-8" data-id="element-251">
                    {study.metrics.map((metric, i) => <div key={i} className="flex flex-col" data-id="element-252">
                        <span className="text-2xl font-bold" data-id="element-253">
                          {metric.value}
                        </span>
                        <span className="text-xs text-gray-500 uppercase tracking-wider font-medium" data-id="element-254">
                          {metric.label}
                        </span>
                      </div>)}
                  </div>
                </div>

                <div className="flex items-end justify-end md:w-24 shrink-0" data-id="element-255">
                  <div className="w-12 h-12 rounded-full border border-gray-200 flex items-center justify-center group-hover:bg-black group-hover:text-white group-hover:border-black transition-all duration-300" data-id="element-256">
                    <ArrowRight className="w-5 h-5" data-id="element-257" />
                  </div>
                </div>
              </Link>
            </motion.div>)}
        </div>
      </motion.div>
    </div>;
}